/**
 * Stripe Keys Configuration
 *
 * IMPORTANT: This file is in .gitignore and will NOT be committed to git.
 *
 * Automatically detects environment based on:
 * 1. Firebase project ID (primary method)
 * 2. Hostname (fallback method)
 *
 * Uses TEST keys for development, LIVE keys for production.
 */

import { firebaseConfig } from "../firebase/firebase";

// ============================================
// ENVIRONMENT DETECTION
// ============================================

// Get Firebase project ID
const firebaseProjectId = firebaseConfig?.projectId || "stoiccredit-64fff";

// Production project ID (update this when you create your production project)
const PRODUCTION_PROJECT_ID = "stoiccredit-64fff"; // Your current production project

// Development project ID (update this when you create your dev project)
// Example: 'stoiccredit-dev' or 'stoiccredit-64fff-dev'
const DEV_PROJECT_ID = "stoiccredit-64fff-dev"; // TODO: Replace with your actual dev project ID

// Detect environment based on Firebase project ID
const isProductionProject = firebaseProjectId === PRODUCTION_PROJECT_ID;
const isDevProject = firebaseProjectId === DEV_PROJECT_ID;

// Fallback: Detect by hostname (for extra safety)
const hostname = typeof window !== "undefined" ? window.location.hostname : "";
const isProductionHostname =
  hostname === "stoiccredit.com" || hostname === "www.stoiccredit.com";
const isLocalhost =
  hostname === "localhost" || hostname === "127.0.0.1" || hostname === "";

// Determine if we're in production
// Priority: Project ID > Hostname > Default to dev
const isProduction =
  isProductionProject || (isProductionHostname && !isDevProject);

// ============================================
// TEST KEYS (Development)
// ============================================
// Use these for localhost and dev Firebase project

const TEST_KEYS = {
  PUBLISHABLE_KEY:
    "pk_test_51S47JJBFGkmQyhgrpox3xItDmcgjgNsdZa1ghGXBdHiWg6Vg2RPk9I0PCMda965UyPNr0mpSN30ii8KOkOMs7qeE00Wy4oiA9t",
  PRODUCTS: {
    MONTHLY: "price_1SCCIiBFGkmQyhgr0Sg163Jz",
    YEARLY: "price_1SCCKvBFGkmQyhgrloC78baD",
  },
};

// ============================================
// LIVE KEYS (Production)
// ============================================
// Use these for production Firebase project (stoiccredit.com)
// TODO: Replace these with your actual LIVE Stripe keys

const LIVE_KEYS = {
  PUBLISHABLE_KEY:
    "pk_live_51S47JABXEaFhPt1w05IGJZirbmxj8mNod5gmdc5iQk0hEfVhl4kR4WqeoR7vp222tYZxFeFCH4KgbZ4W8trTzXkg004bMhAMqa", // TODO: Replace with live key
  PRODUCTS: {
    MONTHLY: "price_1SQH7NBXEaFhPt1wtjOtpz88", // TODO: Replace with live price ID
    YEARLY: "price_1SQHAEBXEaFhPt1w9Ip4ovwg", // TODO: Replace with live price ID
  },
};

// ============================================
// SELECT KEYS BASED ON ENVIRONMENT
// ============================================

const STRIPE_KEYS = isProduction ? LIVE_KEYS : TEST_KEYS;

// ============================================
// DEBUG LOGGING (Development only)
// ============================================

// Debug logging only in development
if (
  typeof window !== "undefined" &&
  process.env.NODE_ENV === "development" &&
  isLocalhost
) {
  /* eslint-disable no-console */
  console.log(" [Stripe Config] Environment Detection:");
  console.log(`   - Firebase Project ID: ${firebaseProjectId}`);
  console.log(`   - Hostname: ${hostname}`);
  console.log(`   - Is Production Project: ${isProductionProject}`);
  console.log(`   - Is Dev Project: ${isDevProject}`);
  console.log(
    `   - Final Environment: ${isProduction ? "PRODUCTION" : "DEVELOPMENT"}`
  );
  console.log(`   - Using ${isProduction ? "LIVE" : "TEST"} Stripe keys`);
  console.log(
    `   - Publishable Key: ${STRIPE_KEYS.PUBLISHABLE_KEY.substring(0, 20)}...`
  );
  /* eslint-enable no-console */
}

// ============================================
// VALIDATION
// ============================================

// Warn if using placeholder keys in production
if (isProduction && STRIPE_KEYS.PUBLISHABLE_KEY.includes("YOUR_LIVE")) {
  console.error(
    " [Stripe Config] WARNING: Using placeholder LIVE keys in production!"
  );
  console.error(
    " Please update LIVE_KEYS in src/config/stripe-keys.js with your actual production keys."
  );
}

export default STRIPE_KEYS;
